<!-- Organization dialog Page @check="handleCheck"  -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="addVisible"
      width="460px"
      @open="dlgOpen"
      @close="closeDialog"
      @closed="dlgClosed"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <div
        :style="dlgBody"
        v-if="addVisible"
      >
        <el-container style="height:100%">
          <el-header style="height:auto;">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
            ></el-input>
          </el-header>
          <el-main style="height:100%;padding:8px;width:100%">
            <el-tree
              v-if="operType!=1"
              class="filter-tree"
              :load="loadNode"
              lazy
              :props="defaultProps"
              :filter-node-method="filterNode"
              node-key="id"
              :check-strictly="true"
              :default-checked-keys="defaultCheckedKeys"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :default-expanded-keys="defaultExpandedKeys"
              @check-change="handleCheckChange"
              show-checkbox
              ref="orgTreeDlg"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
              >
                <!-- <span v-if="data.parent_id == null || data.parent_id==''">
                  <span class="fa fa-folder-open fa-fw"></span>
                </span>
                <span v-else-if="data.type == 1 || data.type=='1'">
                  <span class="fa fa-folder-open-o fa-fw"></span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw"></span>
                </span>
                <span>{{ data.label }}</span>-->
                <span v-if="data.level==0">
                  <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else-if="data.level==1">
                  <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
              </span>
            </el-tree>

            <el-tree
              v-if="operType==1"
              class="filter-tree"
              :data="treeData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              node-key="id"
              :check-strictly="true"
              :default-expand-all="true"
              :default-checked-keys="defaultCheckedKeys"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :default-expanded-keys="defaultExpandedKeys"
              @check-change="handleCheckChange"
              show-checkbox
              ref="orgTreeDlg"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
              >
                <!-- <span v-if="data.parent_id == null || data.parent_id==''">
                  <span class="fa fa-folder-open fa-fw"></span>
                </span>
                <span v-else-if="data.type == 1 || data.type=='1'">
                  <span class="fa fa-folder-open-o fa-fw"></span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw"></span>
                </span>
                <span>{{ data.label }}</span>-->
                <span v-if="data.level==0">
                  <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else-if="data.level==1">
                  <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
              </span>
            </el-tree>
          </el-main>
        </el-container>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onCancel()">取 消</el-button>
        <el-button
          type="primary"
          @click="onSubmit('')"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/** Dialog 自适应高度JS */
import DialogResize from "@/utils/DialogResize.js";
import Utils from "@/utils/Utils.js";
export default {
  mixins: [DialogResize],
  data() {
    return {
      title: "",
      filterText: "",
      editCheckId: "",
      operType: "",
      companyKeyWord: "",
      addVisible: false,
      treeData: [],
      defaultExcludeId: "",
      defaultCheckedKeys: [],
      /** 默认展开的节点 */
      defaultExpandedKeys: [],
      defaultProps: {
        children: "subs",
        label: "name",
        isLeaf: "leaf"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.orgTreeDlg.filter(val);
    }
  },
  methods: {
    init(type, defaultId, excludeId) {
      this.addVisible = true;
      this.filterText = "";
      this.editCheckId = "";
      //   this.operType = 1;
      this.operType = type;
      this.defaultExcludeId = excludeId;
      this.defaultExpandedKeys = [];
      if (this.operType == 1) {
        this.title = "选择公司";
        this.initType1Data();
      } else if (this.operType == 2) {
        this.title = "选择部门";
      } else {
        this.title = "选择组织架构";
      }

      //如果有默认的id 将选中已选过的id
      if (defaultId) {
        this.defaultCheckedKeys.push(parseInt(defaultId));
      }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.operType == 0 || this.operType == 3) {
          this.initType0Data("", "", resolve);
        } else if (this.operType == 2) {
          this.initType2Data("", "", resolve);
        }
        return;
      }
      setTimeout(() => {
        if (this.operType == 0 || this.operType == 3) {
          this.initType0NextData(node.data.type, node.data.id, resolve);
        } else if (this.operType == 2) {
          this.initType2NextData(node.data.type, node.data.id, resolve);
        }
      }, 500);
    },
    initType0Data(type, deptId, resolve) {
      this.$mhttp
        .httpGet(this.$constant.API_NSC+"uc/dept/currentUserDept", null, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            let tranferData = [];
            if (this.operType == 3) {
              tranferData = this.deepTraversal(res.data.data);
            } else {
              tranferData.push(res.data.data);
            }
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data.id);
            }
            this.treeData = tranferData;
            resolve(this.treeData);
          } else {
            this.$message.error(res.data.msg);
            resolve([]);
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
        });
    },
    initType0NextData(type, id, resolve) {
      let param = {};
      //获取组织架构数据
      this.$mhttp
        .httpGet(this.$constant.API_NSC+"uc/dept/depts/" + id, null, null)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.listGroupBranchOrDept = res2.data.data;
            if (resolve) {
              resolve(this.listGroupBranchOrDept);
            }
          } else {
            this.$message.error(res2.data.msg);
            resolve([]);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
          return false;
        });
    },
    //获取公司
    initType1Data() {
      let param = {
        keyword: this.companyKeyWord
      };
      this.$mhttp
        .httpGet(this.$constant.API_NSC+"uc/dept/depts/company", param, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data.id);
            }
            this.treeData = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    initType2Data(type, deptId, resolve) {
      this.$mhttp
        .httpGet(this.$constant.API_NSC+"uc/dept/currentUserDept", null, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            this.treeData = [];
            this.treeData.push(res.data.data);
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data.id);
            }
            resolve(this.treeData);
          } else {
            this.$message.error(res.data.msg);
            resolve([]);
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
        });
    },
    initType2NextData(type, id, resolve) {
      let param = {};
      //获取组织架构数据
      this.$mhttp
        .httpGet(this.$constant.API_NSC+"uc/dept/depts/" + id, null, null)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let tranferData = [];
            tranferData = this.deepTraversal(res2.data.data);
            this.treeData = tranferData;
            if (res2.data.data) {
              this.defaultExpandedKeys.push(res2.data.data.id);
            }
            resolve(this.treeData);
          } else {
            this.$message.error(res2.data.msg);
            resolve([]);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
          return false;
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(item, node, self) {
      if (item.disabled) {
        return;
      }
      this.editCheckId = item.id;
      this.$refs.orgTreeDlg.setCheckedKeys([item.id]);
    },
    handleCheckChange(item, nodeCheck, subNodeCheck) {
      if (nodeCheck) {
        this.editCheckId = item.id;
        this.$refs.orgTreeDlg.setCheckedKeys([item.id]);
      } else {
        if (this.editCheckId == item.id) {
          this.$refs.orgTreeDlg.setCheckedKeys([item.id]);
        }
      }
    },
    onSubmit(formName) {
      let callData = {};
      if (
        this.$refs.orgTreeDlg.getCheckedNodes() &&
        this.$refs.orgTreeDlg.getCheckedNodes().length > 0
      ) {
        callData = this.$refs.orgTreeDlg.getCheckedNodes()[0];
      } else {
        this.$message({
          showClose: true,
          message: "请选择一条记录",
          type: "warning",
          duration: 2000
        });
        return;
      }
      if (
        this.defaultExcludeId != "" &&
        this.defaultExcludeId != null &&
        this.defaultExcludeId != undefined &&
        (this.defaultExcludeId == callData.id ||
          this.defaultExcludeId == callData.parent_id)
      ) {
        this.$message({
          showClose: true,
          message: "上级组织不能选择自己或者自己的下一级",
          type: "warning",
          duration: 2000
        });
        return;
      }
      this.$emit("node-data", callData);
      this.defaultCheckedKeys = [];
      this.addVisible = false;
    },
    onCancel() {
      this.defaultCheckedKeys = [];
      this.addVisible = false;
    },
    closeDialog() {
      this.defaultCheckedKeys = [];
      this.addVisible = false;
    },
    deepTraversal(node) {
      let nodes = [];
      if (node instanceof Array) {
        for (let i = 0, len = node.length; i < len; i++) {
          if (this.operType == 2 && (!node[i].parentId || node[i].level == 1)) {
            node[i].disabled = true;
          } else if (this.operType == 3 && !node[i].parentId) {
            node[i].disabled = true;
          }
          nodes.push(node[i]);
          this.deepTraversal(node[i]);
        }
      } else {
        if (this.operType == 2 && (!node.parentId || node.level == 1)) {
          node.disabled = true;
        } else if (this.operType == 3 && !node.parentId) {
          node.disabled = true;
        }
        nodes.push(node);
        let childrens = node.children;
        if (childrens == null || childrens == undefined) {
          childrens = [];
        }
        for (let i = 0, len = childrens.length; i < len; i++) {
          this.deepTraversal(childrens[i]);
        }
      }
      return nodes;
    }
  }
};
</script>





